<template>
    <div id="faq" class="container">
        <SfBreadcrumbs
                :breadcrumbs="breadcrumbs"
                class="breadcrumbs"
        />

        <OrkLoader :loading="loading">
            <h2 v-if="error && !content" class="error-msg">{{ $t('serviceUnavailable') }}</h2>
            <div v-else-if="content" class="faq">
                <SfHeading :level="1"
                           :title="content.marketing_faq_section_title"
                           class="sf-heading--left">
                </SfHeading>
                <div class="decription" v-html="content.marketing_faq_section_description"></div>

                <div class="list-faq">
                    <SfAccordion
                            :open="content.marketing_faq.marketing_faq_title"
                            show-chevron
                    >
                        <SfAccordionItem
                                v-for="(faq,i) in content.marketing_faq"
                                :key="i"
                                :header="faq.marketing_faq_title"
                        >
                            <p v-html="faq.marketing_faq_content"></p>
                        </SfAccordionItem>
                    </SfAccordion>
                </div>
            </div>
        </OrkLoader>
    </div>
</template>

<script>
import {SfAccordion, SfBreadcrumbs, SfHeading} from "@storefront-ui/vue"
import Api from '@/api/Api';
import {OrkLoader} from "@/components/Ork";

export default {
    name: "Faq",
    components: {
        SfHeading,
        SfAccordion,
        OrkLoader,
        SfBreadcrumbs
    },
    data() {
        return {
            breadcrumbs: null,
            loading: false,
            error: false,
            content: null,
        }
    },
    created() {
        this.setBreadcrumbs();
        this.getContent();
    },
    methods: {
        setBreadcrumbs() {

            this.breadcrumbs = [{
                text: this.$i18n.t('Home'),
                link: '/'
            }, {
                text: this.$i18n.t('Q&A'),
            }];

        },
        getContent() {
            this.loading = true;
            Api.marketing.getFaq()
                .then((data) => {
                    this.content = data;
                })
                .catch((err) => {
                    this.error = true;
                })
                .finally(this.loading = false);
        }
    },
}
</script>

<style lang="scss" scoped>
#faq {
  .list-faq {
    margin-top: var(--spacer-lg);
  }
}

::v-deep {
  .sf-button {
    justify-content: space-between !important;
  }
}

.error-msg {
  text-align: center;
}

h1, h2, h3 {
  // text-transform: uppercase;
}

h2 {
  font-weight: bold;
  margin-top: var(--spacer-xl);
  margin-bottom: var(--spacer-lg);
}

h3 {
  font-weight: 500;
  margin-top: var(--spacer-lg);
  margin-bottom: var(--spacer-base);
}

p {
  margin: var(--spacer-base) 0;
}

::v-deep {
  .sf-accordion-item {
    &__chevron {
      margin: var(--spacer-xs) 0 var(--spacer-xs) var(--spacer-xs);
    }

    .sf-button.sf-accordion-item__header {
      text-align: left;
    }

    &__content {
      padding: 0 var(--spacer-sm);
    }
  }
}
</style>